import React from 'react'
import axios from "axios";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Box } from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import add from "../../../assets/icons/Add.svg";
import minus from "../../../assets/icons/Minus.svg";
import { useState } from "react";
import { Slide } from "react-awesome-reveal";
function FooterCard({item}) {
      const CustomExpandIcon = () => {
          return (
              <Box
                  sx={{
                      ".Mui-expanded & > .collapsIconWrapper": {
                          display: "none",
                      },
                      ".expandIconWrapper": {
                          display: "none",
                      },
                      ".Mui-expanded & > .expandIconWrapper": {
                          display: "block",
                      },
                  }}
              >
                  <div className="expandIconWrapper">
                      {" "}
                      <img src={minus} />
                  </div>
                  <div className="collapsIconWrapper">
                      <img src={add} />
                  </div>
              </Box>
          );
      };
  return (
      <div>
          <Accordion
              className="bg-black py-5 text-white border-y rounded-none border-white"
     defaultExpanded={item.id===1}
          >
              <AccordionSummary
                  expandIcon={<CustomExpandIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
              >
                  <p className="text-[14px] leading-[21px] tracking-[3px]">
                      {item.question}
                  </p>
              </AccordionSummary>
              <AccordionDetails className="flex flex-col gap-3">
                  {item.answer.map((answerItem, index) => (
                      <p key={index} className="text-[14px] leading-[32px] h12">
                          {answerItem}
                      </p>
                  ))}
              </AccordionDetails>
          </Accordion>
      </div>
  );
}

export default FooterCard